import React, { createContext, useContext, useState, ReactNode } from 'react'
import { DetailedStore } from '../types/User'

type StoreContextType = {
  store: DetailedStore | null
  setStore: React.Dispatch<React.SetStateAction<DetailedStore | null>>
  channelFolders: string[]
  setChannelFolders: React.Dispatch<React.SetStateAction<string[]>>
}

const StoreContext = createContext<StoreContextType | undefined>(undefined)

export const StoreProvider = ({ children }: { children: ReactNode }) => {
  const [store, setStore] = useState<DetailedStore | null>(null)
  const [channelFolders, setChannelFolders] = useState<string[]>([])

  return (
    <StoreContext.Provider value={{ store, setStore, channelFolders, setChannelFolders }}>
      {children}
    </StoreContext.Provider>
  )
}

export const useStoreContext = (): StoreContextType => {
  const context = useContext(StoreContext)
  if (!context) {
    throw new Error('useStoreContext must be used within a StoreProvider')
  }
  return context
}
